<template>
  <div>
    <StaffContents
    :profileImg="require('../../assets/img/gen/staff/03/profile.jpg')"
    :profileImgSp="require('../../assets/img/gen/staff/03/profile_sp.jpg')"
    profileAlt="03 冨塚 直人"
    answer01="学生会のリーダーとして学園祭の運営に関わったり、周囲の友人達を巻き込んで夏はキャンプ・冬はスノーボード旅行などの行事を企画したりと、活動的な学生生活を送っていましたね。また、会計学を専門に学んでいたので、就職後も実際の事業運営の中で原価管理について深く学び、それを事業企画や経営に反映させる業務を行いたいと考えていました。"
    answer02="モノづくりをしている企業を中心に就職活動をしていたのですが、決め手となったのはクレハの方の特別講義を聴講したこと。PGA樹脂「Kuredux®」の工業生産に世界で初めて成功したエピソードを生の声で聞くことができ、常に新しいものや世の中の役に立つものを追い求める探究心や、新しい事業にチャレンジする企業風土に強く感銘を受け「ここしかない！」と思いました。"
    answer03="クレハの海外グループ会社として2012年に中国に設立した呉羽(常熟)フッ素材料有限公司(KFPC)にて、人事総務や財務業務の支援、損益予算の作成・損益実績管理、本社への決算や生産状況の報告、本社やグループ会社との連携業務を主に担当しています。KFPCは中国におけるKFポリマーの生産を担っており、グローバル化が加速する社会においてはますます重要な役割を担っていくと考えています。現地の方々との交流も多く、毎日が刺激的です。"
    answer04="入社4年目に、現在所属しているKFPCの立ち上げに関わることができたこと。様々な部門のスペシャリストが集結してひとつの目標に向かっていく様子を目の前で体験し、モノづくり企業のすごさを実感しました。規模の大きな海外プロジェクトでしたが、入社2年目の技術職社員4名もプロジェクトメンバーに抜擢され、「若い人財にも任せる・経験させる」という社風を強く感じましたね。"
    answer05="クレハは「エクセレントカンパニーへの挑戦」をビジョンとして掲げていますが、私の目標はズバリ「クレハをもっとエクセレントにすること」です。ビジネスの国際化が加速度的に進む中、世界では何が起きていて、どこに進もうとしているのか。常にアンテナを張り、10年後のクレハの社会的存在価値を高められる存在になりたい。そのために、既存事業の進め方・新規事業への取り組み方などの戦略を考え、自ら主導していきたいと考えています。"
    answer06="職種や役職に関係なく、役員も含めて社員同士の距離が近いところ。立場や世代の異なる社員と会話をする機会が多いので、今まで自分には持っていなかった考えに触れることができ、思考の幅が広がります。また、学生の方々には「クレラップだけじゃない」ということをもっと知ってもらいたいですね。エンジニアリングプラスチックスや生分解性プラスチックスを始め、医薬品や農薬、グループ会社も含めれば建設や環境事業など、クレハは多方面で世の中に役立つ事業を展開しています。"
    :imageCut01="require('../../assets/img/gen/staff/03/image01.jpg')"
    :imageCut02="require('../../assets/img/gen/staff/03/image02.jpg')"
    :imageCut01Sp="require('../../assets/img/gen/staff/03/image01_sp.jpg')"
    :imageCut02Sp="require('../../assets/img/gen/staff/03/image02_sp.jpg')"
    :schedule="require('../../assets/img/gen/staff/03/schedule.svg')"
    :scheduleSp="require('../../assets/img/gen/staff/03/schedule_sp.svg')"
    />
  </div>
</template>

<script>
import StaffContents from "@/components/gen/StaffContents.vue";
export default {
  name: 'staff_member',
  components: {
    StaffContents
  },
  methods: {
    startIntersectionObserver: function(targets) {
      this.intersectionObserver = new IntersectionObserver(changes => {
        changes.forEach(change => {
          if(change.isIntersecting) {
            change.target.classList.add('is-show');
          }
        });
      },{
        rootMargin: "0px",
        // threshold: [1.0],
      });
      targets.forEach(target => {
        this.intersectionObserver.observe(target);
      });
    },
  },
  mounted() {
    const targets = Array.from(document.querySelectorAll('.faq'));
    this.startIntersectionObserver(targets);
  }
}
</script>
